export interface EditorDraftIntervalSchedulerOptions {
  intervalMs: number;
  /** Se evalúa en cada tick del intervalo */
  canSync: () => boolean;
  onTick: () => void;
}

export interface EditorDraftIntervalScheduler {
  pause(): void;
  resume(): void;
  dispose(): void;
  readonly isPaused: boolean;
}

/** Dispara onTick cada intervalMs (fijo; no depende de inactividad del usuario) */
export function createEditorDraftIntervalScheduler(options: EditorDraftIntervalSchedulerOptions): EditorDraftIntervalScheduler {
  let intervalId: ReturnType<typeof setInterval> | null = null;
  let paused = false;
  let disposed = false;

  const clearIntervalSafe = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const start = () => {
    clearIntervalSafe();
    if (paused || disposed) return;
    intervalId = setInterval(() => {
      if (paused) return;
      if (!options.canSync()) return;
      options.onTick();
    }, options.intervalMs);
  };

  const api = {
    get isPaused() {
      return paused;
    },
    /**
     * Deja de disparar, pero NO reinicia el reloj: el interval sigue corriendo y los ticks se descartan.
     * En el editor de planogramas se pausa en cada drag; si cada pausa reiniciara la cuenta, editando
     * arrastrando piezas (lo habitual) el autoguardado no llegaría a dispararse nunca.
     */
    pause() {
      paused = true;
    },
    resume() {
      if (disposed) return;
      paused = false;
      if (!intervalId) start();
    },
    /** Terminal: después de esto ni resume() puede revivir el scheduler. */
    dispose() {
      disposed = true;
      paused = true;
      clearIntervalSafe();
    },
  };

  start();
  return api;
}
